const Verify = () => {
  
return (
  <div className="p-6 space-y-6 text-cyan-950">
    <h2 className="text-2xl font-bold">Account Verification</h2>
  </div>
  );
};

export default Verify;
